export enum OnboardingTypes {
  ONBOARDING_STEPS = "onboarding-steps",
  NO_ONBOARDING = "",
}

export type OnboardingRequest = {
  name: OnboardingTypes;
};
